module.exports = __webpack_public_path__ + "static/media/business-asset-mgmt-chart-sc.aaf86ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/business-asset-mgmt-chart-sc.png
// module id = 498
// module chunks = 0